import styles from "~/styles/burn-rate.module.css";

interface Scenario {
  margin: number;
  price: number;
  active: boolean;
}

interface ScenarioBarsProps {
  scenarios: Scenario[];
  sym: string;
}

export function ScenarioBars({ scenarios, sym }: ScenarioBarsProps) {
  const maxPrice = Math.max(...scenarios.map((s) => s.price), 1);

  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Escenarios</p>
      <div className={styles.scenarioBars}>
        {scenarios.map((s) => {
          const h = s.price > 0 ? (s.price / maxPrice) * 100 : 0;
          return (
            <div key={s.margin} className={styles.scenarioBarWrap}>
              <div className={styles.scenarioBarTrack}>
                <div
                  className={`${styles.scenarioBarFill} ${s.active ? styles.scenarioBarFillActive : ""}`}
                  style={{ height: `${h}%` }}
                />
              </div>
              <span className={`${styles.scenarioBarMargin} ${s.active ? styles.scenarioBarMarginActive : ""}`}>
                {s.margin}%
              </span>
              <span className={`${styles.scenarioBarPrice} ${s.active ? styles.scenarioBarPriceActive : ""}`}>
                {sym}{s.price.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
